import React from 'react';
import BaseTag from '@jbhi-fi/lanyard-ui/components/Tag/Tag';
import { styles, styleVars } from './Tag.css';
import CalloutFont from '@jbhi-fi/lanyard-ui/font/CalloutFont';
import { ContentTheme } from '../../Contentful/transformers/ThemeTransformer';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
import { Link } from '../../PlatformFunctionality';

export type TagProps = {
  label: string;
  palette?: ContentTheme['palette'];
  icon?: React.ReactNode;
  href?: string;
  className?: string;
};

export const Tag = ({ label, icon, palette, href, className }: TagProps) => {
  return React.createElement(
    href ? Link : 'div',
    {
      className: classNames(className, styles.container),
      href: href as string,
      style: assignInlineVars({
        [styleVars.backgroundColor]: palette?.background ?? 'transparent',
        [styleVars.color]: palette?.text ?? 'inherit',
      }),
    },
    <BaseTag
      className={styles.tag}
      type="info"
      content={
        <>
          {icon ? icon : null}
          <CalloutFont>{label}</CalloutFont>
        </>
      }
    />
  );
};
